/**
 * Portals-specific country flags that reference SVGs from the public folder
 * instead of bundling them as data URIs via imports.
 * This keeps the JS bundle smaller and leverages browser caching for the SVGs.
 */

/** Flag SVG URLs keyed by ISO 639-1 locale codes */
export const flagUrls: Record<string, string> = {
	ca: '/flags/ca.svg',
	de: '/flags/de.svg',
	en: '/flags/en.svg',
	es: '/flags/es.svg',
	eu: '/flags/eu.svg',
	fr: '/flags/fr.svg',
	gl: '/flags/gl.svg',
	it: '/flags/it.svg',
	nl: '/flags/nl.svg',
	pt: '/flags/pt.svg',
};

/** Maps ISO 3166-1 alpha-2 country codes to ISO 639-1 locale codes for flag lookup */
export const countryCodeToLocale: Record<string, string> = {
	AD: 'ca',
	AT: 'de',
	DE: 'de',
	ES: 'es',
	FR: 'fr',
	GB: 'en',
	IT: 'it',
	NL: 'nl',
	PT: 'pt',
	US: 'en',
};

export function Flag({ locale, className, ...props }: { locale: string } & React.ImgHTMLAttributes<HTMLImageElement>) {
	const src = flagUrls[locale];
	if (!src) return null;
	return <img src={src} alt="" width={20} height={20} className={className} {...props} />;
}
